export const sagaActions = {
  // For Authorization / Authentication
  UPDATE_ACCESS_TOKEN: 'UPDATE_ACCESS_TOKEN',
  UPDATE_ID_TOKEN: 'UPDATE_ID_TOKEN',
  CLEAR_TOKENS: 'CLEAR_TOKENS',

  TOGGLE_NOTIFY: 'TOGGLE_NOTIFY',
  SET_LANGUAGE: 'SET_LANGUAGE',
  UPDATE_FACILITY_LIST: 'UPDATE_FACILITY_LIST',
  UPDATE_FACILITY_ORDER: 'UPDATE_FACILITY_ORDER',
  // START UPDATE FOR CREATE ORDER BOOKING AREA
  UPDATE_ORDER_START_DATES: 'UPDATE_ORDER_START_DATES',
  UPDATE_ORDER_END_DATES: 'UPDATE_ORDER_END_DATES',
  UPDATE_ORDER_START_TIME: 'UPDATE_ORDER_START_TIME',
  UPDATE_ORDER_END_TIME: 'UPDATE_ORDER_END_TIME',
  UPDATE_ORDER_PRODUCT_VARIANTS: 'UPDATE_ORDER_PRODUCT_VARIANTS',
  RESET_ORDER_PRODUCT_VARIANTS: 'RESET_ORDER_PRODUCT_VARIANTS',
  UPDATE_ORDER_NUMBER_OF_PEOPLE: 'UPDATE_ORDER_NUMBER_OF_PEOPLE',
  UPDATE_ORDER_CONTACT_OF_REPRESENTATIVE:
    'UPDATE_ORDER_CONTACT_OF_REPRESENTATIVE',
  UPDATE_ORDER_PURPOSE: 'UPDATE_ORDER_PURPOSE',
  UPDATE_ORDER_SALE_OF_GOODS: 'UPDATE_ORDER_SALE_OF_GOODS',
  UPDATE_ORDER_ENTRY_FEE: 'UPDATE_ORDER_ENTRY_FEE',
  UPDATE_ORDER_CALENDAR: 'UPDATE_ORDER_CALENDAR',
  UPDATE_ORDER_RATE: 'UPDATE_ORDER_RATE',
  RESET_ORDER_INPUT: 'RESET_ORDER_INPUT',
  // END UPDATE FOR CREATE ORDER BOOKING AREA
  UPDATE_ORDER_SUCCESS: 'UPDATE_ORDER_SUCCESS',
  UPDATE_PRICE_CALCULATOR: 'UPDATE_PRICE_CALCULATOR',
  RESET_PRICE_CALCULATOR: 'RESET_PRICE_CALCULATOR',
  UPDATE_CUSTOMER: 'UPDATE_CUSTOMER',
  UPDATE_CUSTOMER_INPUT: 'UPDATE_CUSTOMER_INPUT',
  REMOVE_ORDER_SUCCESS: 'REMOVE_ORDER_SUCCESS',
  UPDATE_SAGA_STORE_ID: 'UPDATE_SAGA_STORE_ID',
  UPDATE_ORDERS_FILTER: 'UPDATE_ORDERS_FILTER',
  UPDATE_VALUE_ORDERS_FILTER: 'UPDATE_VALUE_ORDERS_FILTER',
}
